module.exports = __webpack_public_path__ + "img/giftBox_item.805c38ab.svg";